import React from "react";
import { FaPen, FaTrash } from "react-icons/fa";

const SubAdminTable = ({ subadmins, onDelete, onEdit, onManagePermissions }) => {
    if (!subadmins || subadmins.length === 0) {
        return (
            <div className="no-variants-message">
                <p>No Sub-Admins found.</p>
            </div>
        );
    }

    return (
        <div className="luxury-table-container">
            <table className="luxury-table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Username</th>
                        <th>Role</th>
                        <th>Permissions</th>
                        <th style={{ textAlign: 'center' }}>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {subadmins.map((s) => (
                        <tr key={s._id || s.id}>
                            <td style={{ fontWeight: "700", color: "#181c32" }}>{s.name}</td>
                            <td>{s.username}</td>
                            <td>
                                <span className="status-badge type-product" style={{ fontSize: '0.75rem' }}>
                                    {s.role}
                                </span>
                            </td>
                            <td>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <span style={{ fontSize: '0.85rem', fontWeight: '600', color: '#3f4254' }}>
                                            {s.permissions ? [...new Set(s.permissions.map(p => p.split(':')[0]))].length : 0} Modules
                                        </span>
                                        <span style={{ fontSize: '0.7rem', color: '#b5b5c3' }}>
                                            {s.permissions?.length || 0} Total Rights
                                        </span>
                                    </div>
                                    <button 
                                        className="btn-add-product" 
                                        style={{ 
                                            padding: '4px 10px', 
                                            fontSize: '0.7rem', 
                                            background: '#f4f4f4', 
                                            color: '#5e6278',
                                            border: '1px solid #e1e3ea',
                                            borderRadius: '4px',
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => onManagePermissions(s)}
                                    >
                                        Manage
                                    </button>
                                </div>
                            </td>
                            <td>
                                <div className="table-actions" style={{ justifyContent: 'center' }}>
                                    <button className="action-btn edit" onClick={() => onEdit(s)} title="Edit">
                                        <FaPen />
                                    </button>
                                    <button className="action-btn delete" onClick={() => onDelete(s._id || s.id)} title="Delete">
                                        <FaTrash />
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default SubAdminTable;
